export const CONTACT_COMPANY_ADDRESS_INFO =
  'Egli Software GmbH\nRoger & Christian Egli\nSpitalstrasse 29\nCH-6004 Luzern\ninfo@efa-soft.ch'
